export default __webpack_public_path__ + "static/media/203.6ec817b3.png";